import React from 'react';
import PageHero from '../components/PageHero';
import ProductCard from '../components/ProductCard';
import PartnerStrip from '../components/PartnerStrip';
import CtaBand from '../components/CtaBand';
import { capabilities, products, upcomingNote } from '../data/site';
import './pages.css';

const Products: React.FC = () => (
    <>
        <PageHero
            kicker="Product suite"
            title={
                <>
                    Platforms that run the <span className="grad-text">working day</span>
                </>
            }
            description="Five live SaaS products, each built for a specific operational job, all sharing the same cloud, authentication, payments and messaging backbone."
        >
            <div className="chip-row">
                {products.map((product, i) => (
                    <span
                        className="chip chip--dark"
                        key={product.slug}
                        style={{ ['--i' as string]: i }}
                    >
                        {product.name}
                    </span>
                ))}
            </div>
        </PageHero>

        <section className="section section--dark">
            <div className="container">
                <div className="grid grid--2 products-grid">
                    {products.map((product, i) => (
                        <ProductCard key={product.slug} product={product} detailed index={i % 2} />
                    ))}

                    <div
                        className="product-upcoming"
                        data-reveal="up"
                        style={{ ['--i' as string]: 1 }}
                    >
                        <span className="product-upcoming__badge">In build</span>
                        <h3>{upcomingNote.title}</h3>
                        <p>{upcomingNote.description}</p>
                    </div>
                </div>
            </div>
        </section>

        <PartnerStrip />

        <section className="section section--light">
            <div className="container page-split">
                <div data-reveal="left">
                    <span className="kicker">Shared foundation</span>
                    <h2>One backbone under every product</h2>
                    <p className="lede">
                        Because we build the whole family ourselves, a school using Feeisy and
                        PAGARisy gets one login model, one payment setup and one support team —
                        not four vendors pointing at each other.
                    </p>
                </div>
                <ul className="tick-list">
                    {capabilities.map((capability, i) => (
                        <li key={capability} data-reveal="right" style={{ ['--i' as string]: i }}>
                            <span className="tick" aria-hidden="true">
                                ✓
                            </span>
                            {capability}
                        </li>
                    ))}
                </ul>
            </div>
        </section>

        <CtaBand
            title="Want a walkthrough of any platform?"
            description="We will run a live demo against your actual workflow — your fee structure, your salary rules, your service process — so you can see exactly how it fits."
            primaryLabel="Request a demo"
        />
    </>
);

export default Products;
